import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { Colors } from "../../theme";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import HomeSVG from "./Home.svg";
import MobileView from "./MobileView.svg";
import Logo from "../../assets/images/logo64.png";
import {useLocation} from 'react-router-dom'
import './index.css'

export default function Home() {
  const [createAccount, setCreateAccount] = useState(false);
  const location = useLocation();
  useEffect(() => {
    localStorage.clear()
  }, [])

  useEffect(() => {
    if(location.pathname.includes("view-collection")){
      sessionStorage.setItem("routing-path",location.pathname)
    }

  }, [location])
  const changeState = (state) => {
    setCreateAccount(state);
  };
  return (
    <div
      style={{
        height: "100vh",
        background: "#E5E5E5",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",

      }}
    >
      <Row
        className = "hideOnSmall"
        style={{
          // display: "flex",
          // flexDirection: "row",
          // justifyContent: "center",
          // alignItems: "center",
          //  height: "75vh",
          width: '90%',
          background: "white",
          padding: '4rem',
          borderRadius: 12,
        }}
      >
        <Col span={12}>
          <Row align="middle">
            <img src={Logo} alt="sourcewiz" width="40px" height="40px" />
            <span
              style={{
                fontSize: "32px",
                // fontWeight: "bolder",
                color: Colors.black,
                fontFamily: "Gilroy",
                // marginBottom:'2rem'
                marginLeft: "0.5rem",
              }}
            >
              Sourcewiz
            </span>
          </Row>
          <Row style={{ marginTop: "1.5rem" }}>
            <Col span={22}>
              {createAccount ? (
                <SignUp changeState={changeState} />
              ) : (
                <SignIn changeState={changeState} />
              )}
            </Col>
          </Row>
        </Col>
        <Col
          span={12}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",

          }}
        >
          <img src={HomeSVG} alt="sourcewiz" />
        </Col>
      </Row>

      {/* Mobile View starts ------------ */}
      <Row
        className = "displayOnSmall"
        style={{
          width: '80%',
          background: "white",
          padding: '2rem',
          borderRadius: 12,
          boxShadow : '0px 4px 40px 0 rgba(0,0,0,0.2)'
        }}
      >
          <Col span={24} className = "alignCenter">
            <Row align="middle" className = "">
              <img src={Logo} alt="sourcewiz" width="28px" height="28px" />
              <span
                style={{
                  fontSize: "24px",
                  textAlign : "center",
                  color: Colors.black,
                  fontFamily: "Gilroy",
                  marginLeft: "0.5rem",
                }}
              >
                Sourcewiz
              </span>
            </Row>

            <Row align="middle">
              <span
                style={{
                  fontSize: "16px",
                  textAlign: "center",
                  color: Colors.black,
                  fontFamily: "Avenir-Roman",
                  marginTop : '1em',
                }}
              >
                Thanks for visiting the platform!
              </span>
            </Row>

            <Row
              className = "alignCenter"
              style={{
                margin : '2em 0',
              }}
            >
              <img
                src={MobileView}
                alt="sourcewiz"
                width = "80%"
              />
            </Row>

            <Row align="middle">
              <span
                style={{
                  fontSize: "16px",
                  color: Colors.black,
                  fontFamily: "Avenir-Roman",
                  textAlign: "center",
                  fontWeight : "bold",
                }}
              >
                For the best experience, please login to Sourcewiz on desktop or a laptop
              </span>
            </Row>
          </Col>
          {/* Mobile View ends ------------ */}

      </Row>

    </div>
  );
}
